// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"ta_a bhy_b bhy_bj","HomeBaseBanner__hint":"ta_b bhy_vh","HomeBaseBanner__link":"ta_c"};